export enum NavigationStatus {
  Process = 'process',
  Finish = 'finish',
  Wait = 'wait',
}
